export let hideNavigationPaneButton = "m2wLxc";
export let pinNavigationPaneButton = "lKuMN";
export default {hideNavigationPaneButton,pinNavigationPaneButton};